/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1noh358{row-gap:var(--spacingVerticalM);}
.fni485r{flex-wrap:wrap;}
.f122n59{align-items:center;}
.f1869bpl{justify-content:space-between;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fod5ikn{font-size:var(--fontSizeBase400);}
.faaz57k{line-height:var(--lineHeightBase400);}
.fl43uef{font-weight:var(--fontWeightSemibold);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkhj508{font-size:var(--fontSizeBase300);}
.fkfq4zb{color:var(--colorNeutralForeground2);}
.ftrb29c{list-style-type:none;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
.fgdu4nw{padding-inline:0;}
.fnllxr2{padding-block:var(--spacingVerticalM);}
.f12n3xlw{padding-inline:var(--spacingHorizontalM);}
.f1o0qvyv{border-radius:var(--borderRadiusLarge);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1whvlc6{box-shadow:var(--shadow4);}
.fxugw4r{background-color:var(--colorNeutralBackground1);}
.fi15kbk{border-block-start-width:var(--strokeWidthThin);}
.f10zy6vx{border-block-end-width:var(--strokeWidthThin);}
.f32hy0g{border-inline-start-width:var(--strokeWidthThin);}
.fgmlvap{border-inline-end-width:var(--strokeWidthThin);}
.f1taw3pw{border-block-start-style:solid;}
.f1p2dij1{border-block-end-style:solid;}
.fwyddsq{border-inline-start-style:solid;}
.fwl1lcr{border-inline-end-style:solid;}
.foi3q75{border-block-start-color:var(--colorNeutralStroke2);}
.f1a566p{border-block-end-color:var(--colorNeutralStroke2);}
.f1ftuoky{border-inline-start-color:var(--colorNeutralStroke2);}
.f1crbv9w{border-inline-end-color:var(--colorNeutralStroke2);}
.fqerorx{flex-grow:1;}
.fuk1rnt{flex-basis:260px;}
.fuzgk9b{min-inline-size:0;}
.f1j0q4x9{row-gap:var(--spacingVerticalXXS);}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.fjksvth{overflow-wrap:anywhere;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1s184ao{margin:0;}
.f1mk8lai{padding:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fy9rknc{font-size:var(--fontSizeBase200);}
/** @griffel:css-end **/